import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosProjectsPage } from './cronos-projects';

@NgModule({
  declarations: [
    CronosProjectsPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosProjectsPage),
  ],
})
export class CronosProjectsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-projects/cronos-projects.module.ts